import { useState } from 'react';

const ESTADOS_INTERNOS = [
  { value: 301, label: 'Reclamo Recibido', abbr: 'RR' },
  { value: 302, label: 'Enviado a Cotizar', abbr: 'CTZ' },
  { value: 311, label: 'Cotizado', abbr: 'CTZDO' },
  { value: 303, label: 'Asignado', abbr: 'ASIG' },
  { value: 304, label: 'Enviado a Compañía', abbr: 'ACIA' },
  { value: 305, label: 'Retorno de Compañía', abbr: 'RCIA' },
  { value: 306, label: 'Doc en Oficina', abbr: 'DOCOF' },
  { value: 307, label: 'IN/REC', abbr: 'IN/REC' },
  { value: 308, label: 'Terminado', abbr: 'RTER' },
  { value: 309, label: 'Reclamo Cerrado', abbr: 'RCER' },
  { value: 310, label: 'Archivo', abbr: 'RARCH' },
  { value: 400, label: 'Legales', abbr: 'LEGAL' },
];

export default function ReclamosEstadosInternos({ solicitudes }) {
  const [isOpen, setIsOpen] = useState(false);

  // Only solicitudes with estado 904 (CARGADA)
  const cargadas = solicitudes.filter(d => d.estado === 904);

  const counts = ESTADOS_INTERNOS.map(ei => ({
    ...ei,
    count: cargadas.filter(d => d.estadoReclamoValor === ei.value).length,
  })).filter(ei => ei.count > 0)
    .sort((a, b) => b.count - a.count);

  if (cargadas.length === 0) return null;

  return (
    <div className='dashboard-card reclamos-estados-internos'>
      <div className='dashboard-card-header'>
        <button className='estados-internos-toggle' onClick={() => setIsOpen(!isOpen)}>
          <span className='dashboard-card-title'>
            <i className='bi bi-diagram-3-fill'></i>
            Estados Internos (Post-Carga)
          </span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span className='dashboard-card-badge'>{cargadas.length} reclamos cargados</span>
            <div className={`estados-internos-toggle-icon ${isOpen ? 'estados-internos-toggle-icon--open' : ''}`}>
              <i className='bi bi-chevron-down'></i>
            </div>
          </div>
        </button>
      </div>

      <div className={`estados-internos-content ${isOpen ? 'estados-internos-content--open' : ''}`}>
        <div className='estados-internos-grid'>
          {counts.map(ei => (
            <div className='estado-interno-chip' key={ei.value}>
              <span className='estado-interno-count'>{ei.count}</span>
              <div>
                <div className='estado-interno-label'>{ei.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
